import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { CatalogCreatePage } from '@/features/data/catalog/catalog-create-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/catalog/$layer/$database/$table/new')({
  component: NewFieldRoute,
});

function NewFieldRoute() {
  const { tenant, layer, database, table } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="catalog"
      crumbs={[
        { label: t('nav.items.catalog') },
        { label: layer, mono: true },
        { label: database, mono: true },
        { label: table, mono: true },
        { label: t('data.catalog.new.field') },
      ]}
    >
      <CatalogCreatePage tenantId={tenant} parent={{ level: 'table', layer, database, table }} />
    </ConsoleShell>
  );
}
